import React, { useState, useEffect } from "react";
import "./Section3.css";
import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const newsHeadlines = [
  {
    image: "/thumbnail1_Journal_Figma.png",
    title: "Libya Build 2024",
    subtitle: "Our participation in Libya biggest engineering event.",
  },
  {
    image: "/thumbnail2_Journal_Figma.png",
    title: "65 years Celebration",
    subtitle: "Celebrating over six decades of work.",
  },
  {
    image: "/thumbnail3_Journal_Figma.png",
    title: "Collaborations",
    subtitle: "Our significant collaborations throughout the years.",
  },
];

const galleryImages = [
  {
    src: "/Section3_Figma_1.png",
    title: "A Glimpse into the Past",
    body: "Exploring our heritage.",
  },
  {
    src: "/Section3_Figma_2.png",
    title: "New Generations",
    body: "Shaping the future of design in Libya.",
  },
  {
    src: "/Section3_Figma_3.png",
    title: "Engineering Conference",
    body: "Benghazi Construction Exhibition.",
  },
];

export default function Section3() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((p) => (p + 1) % galleryImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const current = galleryImages[currentIndex];

  return (
    <div className="section3">

      <div className="section3-content">

        {/* LEFT */}
        <div className="section3-left">

          <h2 className="section3-title">Journal</h2>

          <div className="section3-news">
            {newsHeadlines.map((item, i) => (
              <div
                key={i}
                className="section3-news-item"
                onClick={() => setCurrentIndex(i)}
              >
                <img src={item.image} alt="" />
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.subtitle}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="section3-bottom">
            <button className="section3-btn">Explore More</button>

            <div className="section3-socials">
              <a href="#"><FontAwesomeIcon icon={faFacebookF} /></a>
              <a href="#"><FontAwesomeIcon icon={faInstagram} /></a>
              <a href="#"><FontAwesomeIcon icon={faLinkedinIn} /></a>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="section3-right">
          <img src={current.src} alt="" />
        </div>

      </div>
    </div>
  );
}